import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { validation, validationText } from "../../utils/constants.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import { useAddbillingMutation, useUpdatebillingMutation } from "../../Redux/services/ClientAPis/billingApi";
import { errorToast, formatDate, success } from "../../utils/helpers.js";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import { useGetpatientsQuery } from "../../Redux/services/ClientAPis/patientApi";

const AddBilling = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [option, setOption] = useState([]);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const { data, isSuccess, isFetching } =
  useGetpatientsQuery(
    {
      search: "",
      limit: pageSize,
      page: page,
    },
    { refetchOnMountOrArgChange: true }
  );

  const [addbilling, { isLoading: addLoading }] = useAddbillingMutation();
  const [updatebilling, { isLoading }] = useUpdatebillingMutation();

  useEffect(() => {
    if (data) {
      const response = data?.data?.map((x) => {
        return { label: x.name, value: x.id };
      });
      setOption(response);
    }
  }, [data]);

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id };
    try {
      let response;
      if (modalData) {
        response = await updatebilling(payload);
      } else {
        response = await addbilling(data);
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("mobile_no", modalData.patient.mobile_no);
      setValue("patient_id", modalData.patient_id);
      setValue("amount", modalData.amount);
      setValue("email", modalData.patient.email);
    } else {
      reset();
    }
  }, []);
  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <ThemeSelect
          name="patient_id"
          control={control}
          options={option}
          rules={{ required: "Patient is required" }}
          errors={errors}
          placeholder={"Patient"}
        />
        <ThemeInput
          name="mobile_no"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"Phone"}
          rules={{
            required: {
              value: true,
              message: validationText.phoneNumber,
            },
            maxLength: {
              value: validation.phoneNumber,
              message: validationText.phoneNumberMax,
            },
          }}
        />
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Email Address"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />

        <ThemeInput
          name="amount"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"$"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <div className="d-flex gap-3 mt-4">
          <div className="btn-submit w-50">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-50">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
            {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Bill"
              ) : (
                "Add Bill"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddBilling;
